import React from "react";

import FileViewer from "react-file-viewer";
import { CustomErrorComponent } from "custom-error";

import { Modal, FormGroup, FormControl, ControlLabel, HelpBlock } from "react-bootstrap";

import "./FilePreviewPopup.css";

const randomKeyGenerator = () =>
    `_${Math.random()
        .toString(36)
        .substring(7)}`;

const HSGPopupBackdropStyle = {
    top: 0,
    backgroundColor: "#000",
    opacity: 0.5
};

class HSGFilePreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getPopUpHeader = headerText =>
        headerText ? <div className="hsg-card-header-label col-md-6 col-sm-6 col-xs-6">{headerText}</div> : null;

    getPopUpHeaderRight = meta => {
      let doc = meta.docMeta || {}
      return (
        <div className="modal-custom-information">
            <div className="row" style={{color: "white"}}>
              <div className="col-md-10 col-sm-10 col-xs-10">
                {this.props.getDocumentName(this.props.meta)}
              </div>
              <div className="right col-md-2 col-sm-2 col-xs-2" style={{ textAlign: "right" }}>
                  <span
                      aria-hidden="true"
                      data-icon="&#e90b;"
                      className="icon-close hsg-icon-close-file"
                      onClick={() => this.props.onHide()}
                  ></span>
              </div>
            </div>
        </div>
    )}

    getButtons = buttons => (
        <div className="text-right">
            {buttons.map((button, i) => (
                <button
                    key={i}
                    className={button.className || "hsg-btn"}
                    onClick={e => this.getButtonActions(e, button.onClick)}
                >
                    {button.text}
                </button>
            ))}
        </div>
    );

    componentWillMount() {}

    componentWillReceiveProps(nextProps) {}

    closeLightbox = () => {};

    render() {
        const { state, props } = this;

        let buttons = [
            {
                className: "hsg-btn right",
                onClick: () => {
                    this.uploadImage();
                },
                text: "Upload"
            },
            {
                className: "hsg-btn-white right",
                onClick: () => {
                    this.props.onHide();
                },
                text: "Close"
            }
        ];

        return (
            <Modal
                show={props.show}
                onHide={props.onHide}
                bsSize={props.bsSize}
                backdropStyle={HSGPopupBackdropStyle}
                dialogClassName={"modal-custom-class"}
            >
                {this.getPopUpHeaderRight(props && props.meta || {})}
                <Modal.Body className="file-preview-body">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div>
                        <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10" key={randomKeyGenerator()}>
                            <FileViewer
                                fileType={props.type ? props.type.split("/")[1] : ""}
                                filePath={props.image}
                                errorComponent={CustomErrorComponent}
                                onError={null}
                                key={randomKeyGenerator()}
                            />
                        </div>
                        <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

{
    /* <div>
{
  this.state.imgUrl && this.state.imgUrl.length > 0 && this.props.isOpen &&
    <Lightbox
        reactModalStyle={styleBody}
        mainSrc={this.state.imgUrl[photoIndex].imageUrl}
        nextSrc={this.state.imgUrl[photoIndex].imageUrl}
        prevSrc={this.state.imgUrl[photoIndex].imageUrl}
        onMovePrevRequest={() => this.previous()}
        onMoveNextRequest={() => this.next()}
        onCloseRequest={() => {this.closeLightbox()}}
        imageTitle={this.renderTitle(this.state.imgUrl[photoIndex])}
        toolbarButtons={[this.renderPDF(), this.deleteButton(this.state.imgUrl[photoIndex])]}
        discourageDownloads={false}
    />
}
</div> */
}

export default HSGFilePreview;



// WEBPACK FOOTER //
// ./src/Containers/HealthLockerContainer/Component/FilePreviewPopup.js